
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Loader2, Plus } from 'lucide-react';
import { CardTitle } from '@/components/ui/card';

interface FeaturedTracksHeaderProps {
  isLoading: boolean;
  onRefresh: () => void;
  onAddTrack: () => void;
}

const FeaturedTracksHeader: React.FC<FeaturedTracksHeaderProps> = ({ 
  isLoading,
  onRefresh,
  onAddTrack
}) => {
  return (
    <div className="flex flex-row items-center justify-between">
      <CardTitle>Featured Tracks</CardTitle>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 size={16} className="mr-2 animate-spin" />
          ) : (
            <RefreshCw size={16} className="mr-2" />
          )}
          Refresh
        </Button>
        
        <Button 
          variant="default" 
          size="sm"
          onClick={onAddTrack}
        >
          <Plus size={16} className="mr-2" />
          Add Track
        </Button>
      </div>
    </div>
  );
};

export default FeaturedTracksHeader;
